import React from "react";

import { Editor } from "~/components/code/editor";
import { useScope } from "~/tools/impulse";
import type { TemplateVariableSuggestion } from "~/tools/template-variables/definitions";

import { PromQLInput } from "../../../metrics/PromQLInput";

import type { WidgetQueryAlias, WidgetQueryMinStep, WidgetQueryPromql } from "./form-state";

export interface WidgetQueryPromqlFieldProps {
	className?: string;
	promql: WidgetQueryPromql;
}

export const WidgetQueryPromqlField: React.FC<WidgetQueryPromqlFieldProps> = ({ className, promql }) => {
	const scope = useScope();

	return (
		<PromQLInput className={className} onChange={(value) => promql.setInput(value)} value={promql.getInput(scope)} />
	);
};

export interface WidgetQueryAliasFieldProps {
	className?: string;
	alias: WidgetQueryAlias;
	suggestions?: ReadonlyArray<TemplateVariableSuggestion>;
}

export const WidgetQueryAliasField: React.FC<WidgetQueryAliasFieldProps> = ({ className, alias, suggestions = [] }) => {
	const scope = useScope();

	return (
		<Editor
			appearance="input"
			className={className}
			language={{ name: "template", variables: suggestions }}
			onChange={(text) => alias.setInput(text)}
			placeholder="Example: '${instance}' will generate series names like 'webserver-123', 'webserver-456'..."
			value={alias.getInput(scope)}
		/>
	);
};

export interface WidgetQueryMinStepFieldProps {
	className?: string;
	minStep: WidgetQueryMinStep;
	suggestions?: ReadonlyArray<TemplateVariableSuggestion>;
}

export const WidgetQueryMinStepField: React.FC<WidgetQueryMinStepFieldProps> = ({
	className,
	minStep,
	suggestions = [],
}) => {
	const scope = useScope();

	return (
		<Editor
			appearance="input"
			className={className}
			language={{ name: "template", variables: suggestions }}
			onChange={(text) => minStep.setInput(text)}
			placeholder="Auto"
			value={minStep.getInput(scope)}
		/>
	);
};
